import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMore = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3539_13173)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M8 7.625C8.20711 7.625 8.375 7.79289 8.375 8C8.375 8.20711 8.20711 8.375 8 8.375C7.79289 8.375 7.625 8.20711 7.625 8C7.625 7.79289 7.79289 7.625 8 7.625Z",
				fill: "#172B4D",
				stroke: "#172B4D",
				strokeWidth: 1.25
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 7.625C12.2071 7.625 12.375 7.79289 12.375 8C12.375 8.20711 12.2071 8.375 12 8.375C11.7929 8.375 11.625 8.20711 11.625 8C11.625 7.79289 11.7929 7.625 12 7.625Z",
				fill: "#172B4D",
				stroke: "#172B4D",
				strokeWidth: 1.25
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 9C4.55228 9 5 8.55228 5 8C5 7.44772 4.55228 7 4 7C3.44772 7 3 7.44772 3 8C3 8.55228 3.44772 9 4 9Z",
				fill: "#172B4D"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3539_13173",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgMore;
